import { Hound } from "../ethers-v5/Hounds";

export const emptyAddress = '0x0000000000000000000000000000000000000000';

export const defaultHound: Hound.StructStruct = {
    breeding: {
        availableToBreed: false,
        lastBreed: 0,
        externalBreedingFee: 0
    },
    stamina: {
        staminaLastUpdate: Number((Date.now() / 1000).toFixed(0)),
        staminaValue: 100
    },
    identity: {
        maleParent: '1',
        femaleParent: '1',
        generation: '1',
        birthDate: Number((Date.now() / 1000).toFixed(0)),
        geneticSequence: [ 0, 1, 6, 6, 1, 2, 3, 4, 4, 3, 2, 1, 5, 4, 3, 1, 9, 1, 4, 2, 4, 7, 1, 2, 6, 5, 8, 3, 9, 9, 8, 1, 1, 7, 2, 7, 9, 1, 0, 9, 1, 1, 2, 1, 0, 7, 2, 2, 8, 5, 8, 7, 1, 3, 0, 9, 4, 1, 7, 4, 5, 8, 1, 3, 7, 2, 5, 9, 7, 3, 5, 0],
        extensionTraits: "",
        specie: 0
    },
    profile: {
        custom: false,
        runningOn: 0,
        token_uri: '',
        name: ''
    }
};